import { render, staticRenderFns } from "./express-routes-popover.vue?vue&type=template&id=298df0de&"
import script from "./express-routes-popover.vue?vue&type=script&lang=js&"
export * from "./express-routes-popover.vue?vue&type=script&lang=js&"
import style0 from "./express-routes-popover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports